import Cookie from 'vue-cookie'

const TOKEN_KEY = 'ADMIN_ACCESS_TOKEN';

export default {
  setToken: function(token) {
    Cookie.set(TOKEN_KEY, token, { expires: 100000, domain: process.env.COOKIE_DOMAIN, path: '/' })
  },

  getToken: function() {
    return Cookie.get(TOKEN_KEY)
  },

  removeToken: function() {
    Cookie.delete(TOKEN_KEY, { domain: process.env.COOKIE_DOMAIN })
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js